import { useBreakpoint } from '../hooks/useBreakpoint';

interface SideDrawerProps {
  children: React.ReactNode;
  onClose: () => void;
}

export default function SideDrawer({
  children,
  onClose,
}: SideDrawerProps) {
  const isDesktop = useBreakpoint('sm');

  return (
    <>
      {/* Backdrop - only on mobile */}
      {!isDesktop && (
        <div
          className="fixed inset-0 z-40 bg-ink-900/20"
          onClick={onClose}
        />
      )}

      {isDesktop ? (
        // Desktop: In-flow side panel (part of 3-column layout)
        <aside className="h-full w-80 shrink-0 border-l border-paper-300 bg-paper-50 shadow-page overflow-hidden flex flex-col">
          {children}
        </aside>
      ) : (
        // Mobile: Bottom drawer
        <div className="fixed bottom-0 inset-x-0 z-50 max-h-[85dvh] bg-paper-50 rounded-t-xl border-t border-paper-300 shadow-page overflow-hidden flex flex-col">
          <div className="mx-auto mt-2.5 mb-1 w-10 h-1 rounded-full bg-paper-300 shrink-0" />
          {children}
        </div>
      )}
    </>
  );
}

interface SideDrawerHeaderProps {
  title: string;
  accentColor: string;
  onClose: () => void;
  onBack?: () => void;
  showBack?: boolean;
}

export function SideDrawerHeader({
  title,
  accentColor,
  onClose,
  onBack,
  showBack = false,
}: SideDrawerHeaderProps) {
  return (
    <div className="flex items-center justify-between px-5 py-4 border-b border-paper-300 shrink-0">
      <div className="flex items-center gap-2">
        {showBack && onBack && (
          <button
            onClick={onBack}
            aria-label="Back"
            className="text-ink-400 hover:text-ink-700 transition-colors text-lg leading-none mr-1"
          >
            ←
          </button>
        )}
        <span
          className="w-2.5 h-2.5 rounded-sm shrink-0"
          style={{ backgroundColor: accentColor }}
        />
        <h2 className="font-serif text-lg font-bold text-ink-900">
          {title}
        </h2>
      </div>
      <button
        onClick={onClose}
        aria-label="Close"
        className="text-ink-400 hover:text-ink-700 transition-colors text-lg leading-none"
      >
        ✕
      </button>
    </div>
  );
}
